export const exercisesOptions = {
    method: 'GET',
    headers: {
      'X-RapidAPI-Key': 'cfaeee8043msh3eacf77a27502a8p1763acjsn9f12a6175ebf',
      'X-RapidAPI-Host': 'exercisedb.p.rapidapi.com'
    },
  };
 

  export const youTubeOptions = {
    method: 'GET', 
    headers: {
      'X-RapidAPI-Key': 'f05fca2fd3mshcbc5eedde91472fp14d960jsne40303e2c6f3',
      'X-RapidAPI-Host': 'youtube-search-and-download.p.rapidapi.com'
    },
  };

export const fetchData = async (url,options) => {
    const response = await fetch(url,options);
    const data = await response.json();
     
    return data;
} 